import RecordsTypeSelect from './RecordsTypeSelect'
import {
    validateEffectiveDate,
    validateOptionalRecordURL,
    validateRecordName,
    validateRecordType
} from '../../services/util/editChecks'
import FormTextField from './FormTextField'
import SmartFormDatePicker from '../3modules/PeopleImport/SmartFormDatePicker'
import {DeleteIconButton} from '../1elements'
import makeStyles from '@material-ui/core/styles/makeStyles'

const TrainingRecordFieldSet = ({index, disabled, showError, updateRecordData, deleteRecord,
                                    recordType, recordName, recordLink, expiryDate, effectiveDate}) => {
    const classes = useStyles()

    const isUsed = recordType||recordName||recordLink||expiryDate||effectiveDate
    const validationRecordType = showError && isUsed && validateRecordType(recordType)
    const validationRecordName = showError && isUsed && validateRecordName(recordName)
    const validationRecordLink = showError && isUsed && validateOptionalRecordURL(recordLink)
    const validationEffectiveDate = showError && isUsed && validateEffectiveDate(effectiveDate)

    return(
        <div className={classes.formRow} key={index}>
            <div className={classes.formRowInside}>
                <div className={classes.formRowRow}>
                    <RecordsTypeSelect className={classes.recordsTypeSelect} value={recordType} disabled={disabled}
                                       onChange={(newValue)=>updateRecordData(index, 'recordType', newValue)}
                                       validation={validationRecordType}/>
                    <FormTextField className={classes.recordsTypeSelect} label={'Record Name'}
                                   hint={'Max. 150 characters'} required value={recordName} disabled={disabled}
                                   onChange={(newValue)=>updateRecordData(index, 'recordName', newValue)}
                                   validation={validationRecordName}/>
                </div>
                <div className={classes.formRowRow}>
                    <FormTextField className={classes.recordsTypeSelect} label={'Record Link'} value={recordLink}
                                   onChange={(newValue)=>updateRecordData(index, 'recordLink', newValue)}
                                   validation={validationRecordLink} disabled={disabled}/>
                    <SmartFormDatePicker value={expiryDate} disabled={disabled} label={'Expiry Date'} disablePast
                                         onChange={(newValue)=>updateRecordData(index, 'expiryDate', newValue.toDate())}/>
                    <SmartFormDatePicker value={effectiveDate} disabled={disabled} label={'Effective Date'} required
                                         onChange={(newValue)=>updateRecordData(index, 'effectiveDate', newValue.toDate())}
                                         validation={validationEffectiveDate}/>
                </div>
            </div>

            <DeleteIconButton onClick={()=>deleteRecord(index)} disabled={disabled} />
        </div>
    )
}

const useStyles = makeStyles({
    root: {
    },
    formRow: {
        display: 'flex',
        margin: '0 0 40px'
    },
    formRowFields: {
        display: 'grid',
        gap: '10px 20px',
        gridTemplateColumns: '1fr 1fr',
        marginLeft: '5px',
        '&>div': {
            flexGrow: 2
        }
    },
    recordsTypeSelect: {
        flexGrow: 2,
        margin: '0 10px'
    },
    formRowInside: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    formRowRow: {
        display: 'flex'
    }
})

export default TrainingRecordFieldSet